import React, { useContext, useState } from 'react'
import { Helmet } from 'react-helmet-async';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import PageTitle from '../../components/pageTitle/PageTitle';
import styles from './contactUs.module.css';
import { Modal, Toast, ToastContainer } from 'react-bootstrap';
import { useFormik } from 'formik';
import { full_name_validator, email_validator, phone_validator, institute_validator, subject_validator, message_validator, files_validator, } from '../../forms/formValidators';
import { Button } from '@mui/material';
import { motion } from 'framer-motion';
import AppContext from '../../contexts/Appcontext';
import { FaCloudUploadAlt } from "react-icons/fa";
import axiosRequest from '../../services/axios/axiosRequest';
import Loading from '../../components/loading/Loading';


export default function ContactUs() {

  const { siteInfos: {
    address, email1, email2, fax, instagram, instagram_id, messenger_phone, phone1, phone2, phone3, phone4, telegram, telegram_id, whatsapp
  } } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowingSuccessToast, setIsShowingSuccessToast] = useState(false);
  const [isShowingFailureToast, setIsShowingFailureToast] = useState(false);

  const contactForm = useFormik({
    initialValues: { full_name: '', email: '', phone: '', institute: '', subject: '', files: null, message: '' },
    validate: (values) => handleContactFormValidation(values),
    onSubmit: (values, { resetForm }) => handleContactFormSubmition(values, resetForm),
  });

  function handleContactFormValidation(values) {
    const errors = {};
    full_name_validator(values, errors);
    email_validator(values, errors);
    phone_validator(values, errors);
    institute_validator(values, errors);
    subject_validator(values, errors);
    files_validator(values, errors);
    message_validator(values, errors);
    return errors;
  }

  function handleContactFormSubmition(values, resetForm) {
    setIsLoading(true);
    // if there is no file, send the form without file
    if (!values.files || values.files.length === 0) {
      delete values.files;
      axiosRequest.post('/contact/', values, { signal: AbortSignal.timeout(10000) })
        .then(() => {
          setIsShowingSuccessToast(true);
          resetForm();
        })
        .catch(() => setIsShowingFailureToast(true))
        .finally(() => setIsLoading(false));
      return;
    }

    // Sending Files One by One
    const uploadFile = async (file) => {
      const fileFormData = new FormData();
      fileFormData.append("file", file);

      return axiosRequest.post('/file/', fileFormData, { signal: AbortSignal.timeout(10000) });
    };

    // Sending all Files and then sending form
    Promise.all(Array.from(values.files).map(uploadFile))
      .then((responses) => {
        const uploadedFiles = responses.map(res => res.data.id); // the API returns file Address and id
        const data = { ...values };
        data["files"] = uploadedFiles;

        return axiosRequest.post('/contact/', data, { signal: AbortSignal.timeout(10000) });
      })
      .then(() => {
        setIsShowingSuccessToast(true);
        resetForm();
      })
      .catch((err) => {
        setIsShowingFailureToast(true);
        console.log(err);
      })
      .finally(() => setIsLoading(false));
  }


  return (
    <div className={styles.pageWrapper}>
      <Helmet>
        <title>تماس با ما - نوآوران پژوه</title>
        <meta name="description" content="اطلاعات تماس شرکت نوآوران پژوه و فرم ارسال درخواست، استعلام قیمت و ثبت سفارش" />
      </Helmet>
      <Header />
      <main className='mainContainer container-lg'>
        <PageTitle title='تماس با ما' style={{ marginBottom: '1.5rem' }} />
        <div className={styles.content_container}>
          {/* Form */}
          <section className={styles.form_container}>
            <motion.div initial={{ y: 30, opacity: 0, }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, ease: 'easeOut' }}>
              <p className='text-light'>جهت ارسال درخواست، استعلام قیمت و یا ثبت سفارش از فرم زیر استفاده کنید</p>
            </motion.div>
            <motion.div initial={{ y: 30, opacity: 0, }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, ease: 'easeOut', }}>
              <form className={styles.form} onSubmit={contactForm.handleSubmit}>
                <div className={styles.inputs_container}>
                  <div className={styles.input_wrapper}>
                    <input className={styles.input} name='full_name' placeholder='نام و نام خانوادگی (الزامی)'
                      value={contactForm.values.full_name}
                      onChange={contactForm.handleChange}
                      onBlur={contactForm.handleBlur} />
                    <p className={styles.errorMessage}>{contactForm.errors.full_name && contactForm.touched.full_name && contactForm.errors.full_name}</p>
                  </div>

                  <div className={styles.input_wrapper}>
                    <input className={styles.input} name='institute' placeholder='نام مرکز (الزامی)'
                      value={contactForm.values.institute}
                      onChange={contactForm.handleChange}
                      onBlur={contactForm.handleBlur} />
                    <p className={styles.errorMessage}>{contactForm.errors.institute && contactForm.touched.institute && contactForm.errors.institute}</p>
                  </div>

                  <div className={styles.input_wrapper}>
                    <input className={styles.input} name='email' placeholder='ایمیل (الزامی)'
                      value={contactForm.values.email}
                      onChange={contactForm.handleChange}
                      onBlur={contactForm.handleBlur} />
                    <p className={styles.errorMessage}>{contactForm.errors.email && contactForm.touched.email && contactForm.errors.email}</p>
                  </div>

                  <div className={styles.input_wrapper}>
                    <input className={styles.input} name='phone' placeholder='شماره همراه (الزامی) 09xxxxxxxxx'
                      value={contactForm.values.phone}
                      onChange={contactForm.handleChange}
                      onBlur={contactForm.handleBlur} />
                    <p className={styles.errorMessage}>{contactForm.errors.phone && contactForm.touched.phone && contactForm.errors.phone}</p>
                  </div>

                  <div className={styles.input_wrapper}>
                    <input className={styles.input} name='subject' placeholder='موضوع (الزامی)'
                      value={contactForm.values.subject}
                      onChange={contactForm.handleChange}
                      onBlur={contactForm.handleBlur} />
                    <p className={styles.errorMessage}>{contactForm.errors.subject && contactForm.touched.subject && contactForm.errors.subject}</p>
                  </div>

                  <div className={styles.input_wrapper}>
                    <label className={`${styles.input} ${styles.fileInputLabel} ${contactForm.values.files ? 'text-dark' : 'text-muted'}`} htmlFor='files'>
                      {contactForm.values.files ?
                        <span className={styles.selectedFiles} >{contactForm.values.files.length} سند ضمیمه شد</span>
                        :
                        <span>ضمیمه فایل</span>}
                      <FaCloudUploadAlt className='fs-4' />
                    </label>
                    <input className={`${styles.input} d-none`} type="file" id="files" name="files" multiple
                      onChange={(event) => contactForm.setFieldValue("files", event.currentTarget.files)} />
                    <p className={styles.errorMessage}>{contactForm.errors.files && contactForm.touched.files && contactForm.errors.files}</p>
                  </div>
                </div>

                <div className={styles.textArea_wrapper}>
                  <textarea className={styles.textarea} name='message' placeholder='پیام (الزامی)'
                    value={contactForm.values.message}
                    onChange={contactForm.handleChange}
                    onBlur={contactForm.handleBlur} />
                  <p className={styles.errorMessage}>{contactForm.errors.message && contactForm.touched.message && contactForm.errors.message}</p>
                </div>

                <Button className={styles.submit} type='submit' variant='contained' color='warning'>ارسال درخواست</Button>

              </form>
            </motion.div>
          </section>

          {/* Contact ways */}
          <section className={styles.contactWays_container}>
            <motion.div initial={{ y: 30, opacity: 0, }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, ease: 'easeOut', }}>
              <p className='text-light fs-5 fw-bold'>اطلاعات تماس</p>
            </motion.div>
            <motion.div initial={{ y: 30, opacity: 0, }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, ease: 'easeOut', }}>
              <address className={styles.contactWays}>
                <div className='d-flex gap-2'>
                  <p>تلفن: </p>
                  <div className='d-flex flex-column row-gap-2 column-gap-4'>
                    <div className='d-flex flex-wrap row-gap-2 column-gap-4'>
                      <a href='tel:+982166996655'>{phone1} </a>
                      <a href='tel:+982166996655'>{phone2} </a>
                    </div>
                    <div className='d-flex flex-wrap row-gap-2 column-gap-4'>
                      <a href='tel:+982166996655'>{phone3} </a>
                      <a href='tel:+982166996655'>{phone4} </a>
                    </div>
                  </div>
                </div>
                <div className='d-flex gap-2'>
                  <p>فکس: </p>
                  <a href='fax:+982166996655'>{fax}</a>
                </div>
                <div className='d-flex gap-2 flex-wrap'>
                  <p>شماره همراه (واتسپ و تلگرام): </p>
                  <a>{messenger_phone}</a>
                </div>
                <div className='d-flex gap-2'>
                  <p>ایمیل: </p>
                  <div className='d-flex flex-column row-gap-2 column-gap-4'>
                    <a href={`mailto:${email1}`}>{email1}</a>
                    <a href={`mailto:${email2}`}>{email2}</a>
                  </div>
                </div>
                {instagram && 
                <div className='d-flex gap-2'>
                  <p>اینستاگرام: </p>
                  <a href={instagram} rel='noreferrer noopener' target='_blank' dir='ltr'>{instagram_id}</a>
                </div>}
                {telegram && 
                <div className='d-flex gap-2'>
                  <p>کانال تلگرام: </p>
                  <a href={telegram} rel='noreferrer noopener' target='_blank' dir='ltr'>{telegram_id}</a>
                </div>}
                {whatsapp && 
                <div className='d-flex gap-2'>
                  <p>کانال واتساپ: </p>
                  <a href={whatsapp} rel='noreferrer noopener' target='_blank' dir='ltr'>{whatsapp}</a>
                </div>}
                <div className='d-flex gap-2'>
                  <p>آدرس: </p>
                  <p>{address}</p>
                </div>
              </address>
            </motion.div>
          </section>

        </div>
      </main >

      <Footer />

      <ToastContainer className="p-3" containerPosition='fixed' position={window.innerWidth < 576 ? "top-center" : 'middle-center'} style={{ zIndex: 4 }}>
        <Toast className='bg-success text-light text-center' show={isShowingSuccessToast} autohide delay={6000} onClose={() => setIsShowingSuccessToast(false)}>
          <Toast.Body>درخواست شما با موفقیت ارسال شد</Toast.Body>
        </Toast>

        <Toast className='bg-danger text-light text-center' show={isShowingFailureToast} autohide delay={6000} onClose={() => setIsShowingFailureToast(false)}>
          <Toast.Body>متاسفانه درخواست با موفقیت ارسال نشد</Toast.Body>
        </Toast>
      </ToastContainer>

      <Modal show={isLoading} centered>
        <Modal.Body className='d-flex flex-column align-items-center gap-3'>
          <p>در حال ارسال درخواست...</p>
          <Loading style={{ position: 'static' }} />
        </Modal.Body>
      </Modal>

    </div >
  )
}
